import React from "react";
import WavyDivider from "./WavyDivider";
import { siteData } from "../mock";

// Decorative SVG ideogram (Shiatsu — pression des doigts)
const IdeogramSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 420" width="160" height="420" aria-hidden="true" className="ideogram-svg">
    <g fill="#6B5A4B" fontFamily="serif" fontSize="64" textAnchor="middle">
      <text x="80" y="80">指</text>
      <text x="80" y="170">壓</text>
      <text x="80" y="260">療</text>
      <text x="80" y="350">法</text>
    </g>
  </svg>
);

const LeShiatsu = () => {
  return (
    <section id="le-shiatsu" className="section le-shiatsu">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Qu’est-ce que le Shiatsu&nbsp;?</h2>
        <h3 className="section-subtitle">
          Le Shiatsu est une pratique manuelle d’origine japonaise qui signifie littéralement «&nbsp;pression des doigts&nbsp;».
        </h3>
      </div>

      <div className="two-col">
        <div className="col-image">
          <img
            src={siteData.images.acupuncture}
            alt="Illustration acupuncture"
            className="acupuncture-img"
          />
        </div>
        <div className="col-text">
          <p>
            Le praticien travaille sur les <strong>méridiens</strong> — canaux énergétiques — et active les <strong>points d’acupuncture</strong> sur tout le corps, en associant <strong>pressions, étirements et mobilisations</strong>.
          </p>
          <p>
            <strong>Puissant, précis et apaisant</strong>, le Shiatsu restaure la libre circulation de l’énergie dans le corps et agit sur <a href="#pourqui" className="inline-link">de nombreux troubles et tensions.</a>
          </p>
          <p className="section-lead">Les bienfaits du Shiatsu</p>
          <p>
            Au niveau <strong>physique</strong>&nbsp;: diminution des tensions musculaires, réduction des douleurs (articulaires, musculaires, menstruelles, chroniques), amélioration de la posture et de la circulation, action sur les troubles du sommeil, réduction de la fatigue et énergie vitale retrouvée.
          </p>
          <p>
            Au niveau <strong>psychologique</strong>&nbsp;: meilleure concentration et créativité, réduction de l’anxiété, stabilité émotionnelle et meilleure gestion du stress.
          </p>
          <a href="#seances" className="underline-link">LES SÉANCES</a>
        </div>
      </div>

      <div className="ideogram-banner" aria-hidden="true">
        <IdeogramSVG />
        <div className="ideogram-caption">
          <div>Shiatsu 指壓</div>
          <div className="muted">pression des doigts</div>
        </div>
      </div>
    </section>
  );
};

export default LeShiatsu;
